import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import OpenPositions from '../components/OpenPositions';
import PendingOrders from '../components/PendingOrders';
import TradeHistory from '../components/TradeHistory';
import CustomNotification from '../components/CustomNotification';
import CustomConfirm from '../components/CustomConfirm';
import { FileText, Clock, CheckCircle, ArrowLeft, LineChart, Briefcase, User, Newspaper, MessageCircle, Calendar } from 'lucide-react';

// Runtime detection
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

function PositionsPage({ user, setUser }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('open'); // 'open', 'pending', 'completed'
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showNewsMenu, setShowNewsMenu] = useState(false);
  
  // Custom notification states
  const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });
  const [confirm, setConfirm] = useState({ show: false, message: '', onConfirm: null });

  const tabs = [
    { id: 'open', icon: FileText, label: 'Açık Pozisyonlar' },
    { id: 'pending', icon: Clock, label: 'Bekleyen Emirler' },
    { id: 'completed', icon: CheckCircle, label: 'Tamamlanan İşlemler' }
  ];

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Navbar user={user} setUser={setUser} />
      
      {/* Page Header */}
      <div className="bg-gray-800 border-b border-gray-700 px-4 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <button
              onClick={() => navigate('/dashboard')}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <ArrowLeft size={24} />
            </button>
            <h1 className="text-2xl font-bold">📊 Pozisyonlarım</h1>
          </div>
          <p className="text-sm text-gray-400">Açık pozisyonlarınızı, bekleyen emirlerinizi ve işlem geçmişinizi görüntüleyin</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="sticky top-16 bg-gray-800 border-b border-gray-700 z-40">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex">
            {tabs.map(tab => {
              const TabIcon = tab.icon;
              return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1 px-1.5 py-3 text-[10px] font-semibold whitespace-nowrap transition-colors ${
                  activeTab === tab.id
                    ? 'text-blue-500 border-b-2 border-blue-500'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <TabIcon size={14} />
                <span>{tab.label}</span>
              </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto p-4 page-content-with-nav">
        {activeTab === 'open' && (
          <OpenPositions
            user={user}
            selectedAsset={null}
            refreshTrigger={refreshTrigger}
            setNotification={setNotification}
            setConfirm={setConfirm}
            showTitle={false}
            onPositionClick={(position) => {
              // Navigate to trading page with the asset selected
              const symbol = position.asset_symbol || position.symbol;
              console.log('🔄 Navigating to trading page for:', symbol);
              navigate(`/trading?symbol=${symbol}`);
            }}
          />
        )}
        
        {activeTab === 'pending' && (
          <PendingOrders
            user={user}
            selectedAsset={null}
            refresh={refreshTrigger}
          />
        )}
        
        {activeTab === 'completed' && (
          <TradeHistory
            user={user}
            selectedAsset={null}
            refreshTrigger={refreshTrigger}
            showTitle={false}
          />
        )}
      </div>

      {/* Custom Notification Modal */}
      <CustomNotification
        show={notification.show}
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ show: false, message: '', type: 'info' })}
      />

      {/* Custom Confirm Modal */}
      <CustomConfirm
        show={confirm.show}
        message={confirm.message}
        onConfirm={() => {
          if (confirm.onConfirm) confirm.onConfirm();
          setConfirm({ show: false, message: '', onConfirm: null });
        }}
        onCancel={() => setConfirm({ show: false, message: '', onConfirm: null })}
      />

      {/* Bottom Navigation - Global component App.js'de */}
    </div>
  );
}

export default PositionsPage;
